export const MILESTONE_FETCH_REQUEST = 'MILESTONE_FETCH_REQUEST';
export const MILESTONE_FETCH = 'MILESTONE_FETCH';
export const MILESTONE_CREATE_REQUEST = 'MILESTONE_CREATE_REQUEST';
export const MILESTONE_CREATE = 'MILESTONE_CREATE';
export const MILESTONE_DELETE_REQUEST = 'MILESTONE_DELETE_REQUEST';
export const MILESTONE_DELETE = 'MILESTONE_DELETE';
export const MILESTONE_UPDATE_REQUEST = 'MILESTONE_UPDATE_REQUEST';
export const MILESTONE_UPDATE = 'MILESTONE_UPDATE';
